<div class="d-flex justify-content-end align-items-center">
    <button id="new" class="history-btn " type="button" (click)="copy()" [disabled]="isDisabled" [ngClass]="{'disabled': isDisabled}">Copy</button>
</div>
